<div class="loading-container" style="position: fixed;z-index: 99">
  <div class="inline-container">
    <div class="lds-roller">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
    <div class="text">
     Lütfen Bekleyiniz
    </div>
    <div class="text clickable text-blue" (click)="hide()">
      Gizle
    </div>
  </div>
</div>
